<template>
  <FlatButtonStyle :variant="variant" :size="size">
    <a :class="$style.content">
      <slot name="icon" v-if="$slots.icon" />
      <span v-if="$slots.default" :class="$style.content__text">
        <slot />
      </span>
    </a>
  </FlatButtonStyle>
</template>

<script lang="ts">
export {
  type Variant,
  type Size,
  sizes,
  variants,
} from '@/components/atoms/FlatButtonStyle.vue'
</script>

<script setup lang="ts">
import FlatButtonStyle, {
  type Variant,
  type Size,
} from '@/components/atoms/FlatButtonStyle.vue'

defineProps<{ variant: Variant; size: Size }>()
</script>

<style lang="scss" module>
.content {
  display: flex;
  align-items: center;
  justify-content: center;

  &__text {
    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}
</style>
